import { useState } from 'react';
import Switch from 'Components/switch';
import Modal from 'Components/Modal';
import ModalEdit from './ModalEdit';
import Alert from '../../../Components/Alert';

export default function RoleRow({ role, setRoles, t, allRoles }) {
  const [openModal, setOpenModal] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  if (role.name === 'Administrador' || role.name === 'Empleado') {
    return null;
  } else {
    return (
      <>
        <Switch active={role.active} color="success" event={() => setOpenModal(true)} />
        <Modal
          open={openModal}
          size="sm"
          Children={
            <ModalEdit
              data={role}
              cancel={() => setOpenModal(false)}
              accept={() => {
                setOpenModal(false);
                setOpenAlert(true);
                setRoles(prev => prev.map(r => (r.id === role.id ? { ...r, active: !r.active } : r)));
              }}
              allRoles={allRoles}
              setAllRoles={setRoles}
              isActive={role.active}
            />
          }
        />
        <Alert message={t('Generic.AlertTitle')} open={openAlert} setOpen={setOpenAlert} />
      </>
    );
  }
}
